import ProviderIncentiveCost from './provider-incentive-cost-container';

export default ProviderIncentiveCost;
